<template>
  <div class="workerorderindex" @scroll="scorllBottom">
    <top></top>
    <div class="nav">
      <router-link style="color:rgb(31, 55, 61);"  :to="urlb" >
          <span @click="hisback">首页</span>
      </router-link>
      <span class="navbread">{{'>'+questionclass}}</span>
      <router-link class="btna color" :to="{ path: '/myorder'}" :style="{backgroundColor:boxBodyColor}">我的工单</router-link>
    </div>
    <div class="noGetList" v-if="orderdata.length == 0 && contentis && noGetListShow">
      您还未提交工单哦~
    </div>
    <div class="content" v-show="contentis" >
      <p v-for="(item,index) in orderdata">
         <span :id="'d'+index" class="tishi">
          <span >{{item.orderName}}</span>
          <a></a>
        </span>
        <span style="width:100px;" v-if="item.orderName.length>=6" @mouseenter.stop="block(index)" @mouseleave.stop="none(index)">{{ reversedMessage(item.orderName)}}</span>
         <span style="width:100px;" v-else>{{item.orderName}}</span>
        <span class="number">{{item.processInstanceId}}</span>
        <span class="cls" v-if="item.status==10">已完成</span>
         <span class="cls orange" v-else>处理中</span>
        <span class="date">{{item.startTime}}</span>
        <span class="im" @click="sessitem(item.orderName)">
          <router-link  :to="{path:'/workdetail?',query:{'id':item.processInstanceId}}" >
            <img src="../../assets/workorder/arrow.png" style="display:block;margin-top:15px">
          </router-link>
        </span>
      </p>
    </div>
    <div class="login" v-show="loginis">
        <p>手机号为查看单据处理结果的依据</p>
        <div>
          <span>手机号</span>
          <el-input v-model="phone" class="phonenumber" placeholder="请输入手机号码" @blur="phonego"></el-input>
          <p >{{phoneis}}</p>
        </div>
        <div class="mat">
          <span>随机码</span>
          <el-input v-model="verify" class="verify" placeholder="短信随机码" ></el-input>
          <span v-if="verifyis" class="verifybtn" @click="verifygo" :style="{backgroundColor:boxBodyColor}">获取随机码</span>
          <span v-else class="verifybtn" :style="{backgroundColor:boxBodyColor}">{{timesecond+"s"}}</span>
           <p>{{veris}}</p>
        </div>
        <el-button class="color verbtn" type="primary" @click="verifyconfirm" :style="{backgroundColor:boxBodyColor}">下一步</el-button>
    </div>
  </div>
</template>

<script>
import * as Urls from '../url.js'
import top from '../workorder/top.vue'
import axios from '@/utils/request.js'
export default {
  name: 'myorder',
  components: {
    top
  },
  data () {
    return {
      urlb:'',
      boxBodyColor:'',
      logoUrl:'',
      companyName:'',
      displayMode:'',
      btnis:false,
      kefuis:false,
      phone:"",
      phoneis:"",
      veris:'',
      verify:"",
      verifyis:true,
      timesecond:60,
      questionclass:"我的工单",
      orderdata:[],
      basurl:Urls.baseurl,
      md5:"",
      loginis:true,
      contentis:false,
      noGetListShow:false,
      page: 1
   }
  },
  mounted(){
    var vm=this;
     vm.boxBodyColor = sessionStorage.getItem('boxBodyColor')
      vm.companyName = sessionStorage.getItem('companyName')

      vm.logoUrl = sessionStorage.getItem('logoUrl')
      vm.displayMode = sessionStorage.getItem('displayMode')
     this.href= window.location.href.split("?")[1];
     this.md5=sessionStorage.getItem("md5");
     this.showis()
      //判断客服是否显示
       axios.get(this.basurl+'/api/visitor/product/conf/showOnlineService?visitorMd5Code='+this.md5).then(function(response){
          if(response.data.code==1){
            vm.kefuis=true;
          }
       });
      var indexurl=sessionStorage.getItem("indexUrl");
      if (indexurl == 'workerorderindex') {
         vm.urlb="workerorderindex"
      } else if (indexurl == 'aiInteractive') {
         vm.urlb="aiInteractive?v="+this.md5
      }
  },
  methods:{
    block(index){
      var dom=document.getElementById("d"+index);
      dom.style.display = 'block';
    },
     none(index){
      var dom=document.getElementById("d"+index);
      dom.style.display = 'none';
    },
    sessitem(data){
      sessionStorage.setItem("butianitem",data)
    },
    reversedMessage(string){
      var arr=string.split("");
      var rstring=""
      if(arr.length<=5){
        rstring=string;
      }else{
        for(var i=0;i<5;i++){
          rstring=rstring+arr[i]
        };
        rstring=rstring+"..."
      }
      return rstring
    },
     //判断跳转页面

    kefugo(){
        var vm=this;
        axios.get(this.basurl+'/api/visitor/product/conf/redirectToOnlineService?visitorMd5Code='+this.md5).then(function(response){
          //console.log(response)
          if(response.data.code==1){
            var obj=response.data.data;

            if(obj.imStatus=="waiting"){
              vm.$router.replace({path: 'imLineUp'});
              //window.location.href="#/imLineUp";

            }else if(obj.imStatus=="chatting"){
                vm.$router.replace({path: 'imSession'});
               //window.location.href="#/imSession";
            }else{
                if(obj.target==1){
                  //window.location.href="#/spirit";
                  vm.$router.replace({path: 'spirit'});
                  console.log('已经跳转了');
                }
                if(obj.target==2){
                  vm.$router.replace({path: 'imDirectory'});
                  //window.location.href="#/imDirectory";
                }
            }
          }
        })
    },
    //判断是否授权
    showis(){
      var vm=this;
      axios.get(this.basurl+'/api/visitor/wo/workOrderList?visitorMd5Code='+this.md5 +'&page=1&size=50').then(function(response){
        var da=response.data
        //console.log(da)
        if(da.code==1){
          vm.showdata()
          vm.loginis=false;
          vm.contentis=true;
        }else if(da.code==401){
          vm.contentis=false;
          vm.loginis=true;
        }
     })
    },
    showdata(){
      var vm=this;
      axios.get(this.basurl+'/api/visitor/wo/workOrderList?visitorMd5Code='+this.md5 + '&page=1&size=50').then(function(response){

         if(response.data.code==1){
            response.data.data.forEach( function(element, index) {
              vm.orderdata.push(element)
            });

           if(vm.orderdata.length > 0){
             vm.noGetListShow = false
           }else {
             vm.noGetListShow = true
           }
         }
       })
    },
     phonego(){
      var phonenumis=/^1\d{10}$/.test(this.phone);
      //console.log(phonenumis)
      if(phonenumis==false){
        this.phoneis="手机号格式错误"
      }else{
        this.phoneis="";
      }
    },
     //手机验证
    verifyconfirm(){
      //console.log( this.verify)
      var vm=this;
      vm.veris="";
      if(this.verify!=""&& this.btnis==true){
         axios.post(this.basurl+'/api/visitor/wo/msgCaptchaValid?visitorMd5Code='+this.md5+"&phoneNum="+this.phone+"&code="+this.verify).then(function(response){
            if(response.data.code==1){
              vm.showis();
              vm.veris="";
            }else if(response.data.code==0){
               vm.veris="验证码已过期请重新获取"
            }else if(response.data.code==4032){
              this.$message.error('获取验证码过于频繁')
            }else{

              vm.veris="验证码填写错误"
            }
         })
      }else{
        vm.veris="请获取验证码"
      }

    },
    verifygo(){
      var vm =this;
      if(this.phone==''){
        this.phoneis="手机号不能为空"
      }
      if(this.phoneis!="手机号格式错误"  &&  this.phoneis!="手机号不能为空"){
         axios.get(this.basurl+'/api/visitor/wo/msgCaptcha?visitorMd5Code='+this.md5+"&phoneNum="+this.phone).then(function(response){
          console.log(response)
          vm.btnis=true;
            if(response.data.code==1){
                 vm.verifyis=false;
                 var timer = setInterval(function () {
                    vm.timesecond= vm.timesecond-1;
                    if( vm.timesecond==0){
                      clearInterval(timer);
                      vm.verifyis=true;
                       vm.timesecond=60;
                    }
                 },1000)
            }else if(response.data.code==4032){
               vm.$message.error('验证码获取过于频繁');
            }else if(response.data.code==4504){
              vm.$message.error('验证码已过期请重新获取');
            }
         })

      }
    },
    hisback(){
      var vm=this;
      var indexurl=sessionStorage.getItem("indexUrl");
      console.log(indexurl)
      var imEntranceMode=sessionStorage.getItem("imEntranceMode");
      console.log(imEntranceMode)
      if (indexurl == 'aiInteractive') {
        window.location.href = "#/aiInteractive?v="+this.md5
         vm.urlb="aiInteractive?v="+this.md5
      } else if (indexurl == 'workerorderindex') {
        window.location.href = "#/workerorderindex"
         vm.urlb="workerorderindex"
      }else {
         axios.get(this.basurl+'/api/visitor/im/sessionStatus?visitorMd5Code='+this.md5).then(function(response){
            console.log(response);
            let imStatus = '';
            if(response.data.code==1){
              imStatus=response.data.data.status;
            }
              console.log(imStatus)
                if ((imStatus === 'ended' || !imStatus || imStatus === '') && indexurl == 'spirit') {
                  vm.urlb="spirit"
                  window.location.href="#/spirit"

                  return
                } else if (imStatus === 'waiting') {
                  vm.urlb="imLineUp"
                  window.location.href="#/imLineUp"

                  return
                } else if (imStatus === 'chatting') {
                  vm.urlb="imSession"
                  window.location.href="#/imSession"

                  return
                } else {
                  if (imEntranceMode === 1) {
                      vm.urlb="imLineUp"
                     window.location.href="#/imLineUp"
                  } else if (imEntranceMode === 2) {
                      vm.urlb="imDirectory"
                      window.location.href="#/imDirectory"

                  }
               }

            console.log(vm.urlb)
          })
      }
    },
    scorllBottom(event){
      var vm = this
      var event = event || window.event
      if(event.target.scrollTop + 620 >= event.target.scrollHeight) {

        vm.page = vm.page + 1
        axios.get(this.basurl+'/api/visitor/wo/workOrderList?visitorMd5Code='+this.md5 + '&page='+ vm.page +'&size=50').then(function(response){

          if(response.data.code==1){

            response.data.data.forEach( function(element, index) {
              vm.orderdata.push(element)
            });

            if(vm.orderdata.length > 0){
              vm.noGetListShow = false
            }else {
              vm.noGetListShow = true
            }
          }
        })
      }

    },


  }
}
</script>

<style scoped>
 .top .title_img{
  display: inline-block;
  float: left;
  height: 35px;
  width: auto;
  margin: 5px 0 5px 20px;
}
.top .title_2{
  color:#fff;
  display: inline-block;
  float: left;
  margin-left:20px;
}
.top .title_2 span{
  font-size: 16px
}
.verbtn{
    display: block;
    width: 100px;
    margin: 0 auto;
    margin-top: 20px;
  }
  .verifybtn{
    display: inline-block;
    width: 120px;
    height: 36px;
    background:#36c6d3;
    border-radius: 4px;
    color: #ffffff;
    text-align: center;
    line-height: 36px;
    margin-left: 10px;
    cursor: pointer;
  }
  .login{
    width: 370px;
    margin: 0 auto;
  }

  .login p{
    margin-top: 100px;
    font-size: 12px;
    color: #999999;
    margin-bottom: 4px;
    margin-left: 64px;
  }
  .login div p{
    color: #ed6b75;
    margin-top: 4px;
    height: 14px;
  }
  .login div span{
    font-size: 14px;
    color: #666666;
    margin-right: 18px;

  }
  .login div .verifybtn{
      color: #ffffff;
      margin-right: 0;
  }
  .login div .phonenumber{
    width: 300px;
  }
  .login div .verify{
    width: 165px;
  }
  .content{
    width: 470px;
    border-radius: 6px;
    margin:0 auto;
    font-size: 14px;
    color: #666666
  }
  .content p{
    width: 470px;
    line-height: 50px;
    height: 50px;
    border-bottom: 1px solid #cccccc;
    position: relative;
  }
  .content p .tishi{
    position: absolute;
    top: -48px;
    left: -8px;
    padding: 0 10px;
    display: block;
    color: #ffffff;
    display: none;
    background:#000000;
    border-radius: 4px;
  }
  .content p .tishi a{
    border:10px solid black;
    position: absolute;
    top: 50px;
    left: 20px;
    border-color:black transparent transparent transparent;
  }
  .content span{
    display: block;
    float: left;
  }
  .number{
    margin-left: 24px;
  }
  .cls{
    margin-left: 36px;
  }
  .content p .orange{
    color: #fe986a;
  }
  .im{
    margin-left: 30px;
    color: red;
    cursor: pointer;
  }
  .date{
    margin-left: 25px;
    font-size: 12px;
  }
 .workerorderindex{
  background: #f8f8f8;
  width: 100%;
  height: 100%;
   overflow: auto;
 }
 .color{
  background: #009688;
 }
 .top{
   height: 46px;
   width: 100%;
 }
 .logo{
  margin-left: 20px;
  width: 140px;
  height: 34px;
  margin-top: 6px;
 }
 .top img,.top span{
  display: block;
  float: right;
  color: #fff;
  font-size:14px;
  cursor: pointer;
 }
 .top span{
  line-height: 46px;
  margin-left: 10px;
 }
 .kefu{
  position: absolute;
  right: 86px;
  margin-top: 11px;
 }
 .nav{
  width: 560px;
  margin:0 auto;
  height: 45px;
  border-bottom: 1px solid #000;
  font-size: 14px;
 }
 .nav span{
  line-height: 45px;
  color: #5987c2;
   font-weight:bold;
  text-decoration: underline;
 }
  .nav .btna{
    display: block;
    color: white;
    font-size: 14px;
    width: 70px;
    height: 24px;
    float: right;
    border-radius: 4px;
    text-align:center;
    line-height: 24px;
    margin-top: 11px;
  }
  .nav .navbread{
    text-decoration: none;
    color: #000;
    font-weight:bold;
  }
 .noGetList {
   text-align: center;
   margin-top: 80px;
   font-size: 18px;
   color: #999999;
   font-weight: bold;
 }
</style>



// WEBPACK FOOTER //
// src/components/workorder/myorder.vue?66d065ed